import PropTypes from 'prop-types'
import React, { Component } from 'react'

class References extends Component {
  state = {}
  emphasizeMe = authors => {
    return authors.replace('Siwei Fu', '<strong>Siwei Fu</strong>')
  }
  renderIcons = paper => {
    const pdf = paper.pdf ? (
      <a href={paper.pdf} className="icon fa fa-file-o" />
    ) : null
    const video = paper.video ? (
      <a href={paper.video} className="icon fa fa-play" />
    ) : null
    const url = paper.url ? (
      <a href={paper.url} className="icon fa fa-globe" />
    ) : null
    return (
      <div className="icons">
        {video}
        {pdf}
        {url}
      </div>
    )
  }
  render = () => {
    const { papers } = this.props

    if (!papers) return

    var onepaper = papers.map((paper, i) => {
      return (
        <tr className="eachrow" key={i}>
          <td className="pubnum">{paper.pubnum}</td>
          <td className="teaser">
            <a href={paper.pdf || paper.url}>
              <img className="thumbnail" src={paper.teaser} />
            </a>
            <span className="venue">{paper.venue}</span>
          </td>
          <td className="content">
            <a href={paper.pdf || paper.url}>
              <strong>{paper.title}</strong>
            </a>
            <br />
            <div
              className="authors"
              dangerouslySetInnerHTML={{
                __html: this.emphasizeMe(paper.authors),
              }}
            />
            <em className="venueLong">{paper.venueLong}, {paper.year}</em>
            {this.renderIcons(paper)}
          </td>
        </tr>
      )
    })

    return (
      <table className="publication">
        <tbody>{onepaper}</tbody>
      </table>
    )
  }
}

References.displayName = 'References'
References.propTypes = {
  images: PropTypes.array,
}

export default References



// WEBPACK FOOTER //
// ./src/components/references.js